const state = () => ({
    main: []
})

const mutations = {
    setVideos(state, { video }) {
        state.main.push(video)
    },
    replaceVideo(state, { item }) {
        state.main.splice(item.index, 1, item)
    },
    deleteVideo(state, { index }) {
        state.main.splice(index, 1)
    },
    clearAll(state) {
        state.main = []
    }
}

const actions = {
    async setVideos({ commit }, { video }) {
        commit('setVideos', { video })
    },
    async replaceVideo({ commit, dispatch }, { item }) {
        await commit('replaceVideo', { item })
        dispatch('price/setPrice', null, { root: true })
    },
    async deleteVideo({ commit, dispatch }, { index }) {
        await commit('deleteVideo', { index })
        dispatch('price/setPrice', null, { root: true })
    },
    async clearAll({ commit }) {
        commit('clearAll')
    }
}

const getters = {
    main: state => state.main
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};